import React, { Component } from "react";
import {
  Container,
  Divider,
  Grid,
  Menu,
  Segment,
  Image,
  Header
} from "semantic-ui-react";

import Scroll from "react-scroll";
import GoogleMapReact from "google-map-react";
import FacebookProvider, { Like } from "react-facebook";

import Main from "./Main";
import ServiceItem from "./ServiceItem";

let Link = Scroll.Link;
let Events = Scroll.Events;
let scroll = Scroll.animateScroll;
let scrollSpy = Scroll.scrollSpy;

const serviceList = [
  {
    name: "Printing",
    info:
      "Black and White copies as low as 2 cents and Color copies as low at 15 cents!"
  },
  {
    name: "Scanning",
    info:
      "Drowning in old files? Let us help you by scanning your paper files into searchable PDFs!"
  },
  {
    name: "Legal Copies",
    info: ""
  },
  { name: "Booklets and Binding", info: "" },
  { name: "Blue Prints", info: "" },
  { name: "Business Cards", info: "" }
];

class App extends Component {
  state = { activeItem: "main" };

  handleItemClick = (e, { name }) => this.setState({ activeItem: name });

  componentDidMount = () => {
    Events.scrollEvent.register("begin", (to, element) => {
      console.log("begin", arguments);
    });

    Events.scrollEvent.register("end", (to, element) => {
      console.log("end", arguments);
    });

    scrollSpy.update();
  };
  componentWillUnmount = () => {
    Events.scrollEvent.remove("begin");
    Events.scrollEvent.remove("end");
  };

  scrollToTop = () => {
    scroll.scrollToTop();
  };

  scrollTo = () => {
    scroll.scrollTo(100);
  };

  render() {
    return (
      <Container>
        <Grid verticalAlign="middle">
          <Grid.Row>
            <Grid.Column computer={16} mobile={16} tablet={16}>
              <Menu inverted>
                <Link to="services" spy={true} smooth={true} duration={500}>
                  <Menu.Item name="Services" />
                </Link>
                <Link to="contact" spy={true} smooth={true} duration={500}>
                  <Menu.Item name="Contact" />
                </Link>
                <Link to="about" spy={true} smooth={true} duration={500}>
                  <Menu.Item name="About" />
                </Link>
              </Menu>
            </Grid.Column>
          </Grid.Row>

          <Main />

          <Grid.Row id="services" className="element">
            {serviceList.map((service, index) => (
              <ServiceItem key={index} {...service} />
            ))}
          </Grid.Row>

          <Divider section />

          <Grid.Row id="contact" className="element">
            <Grid.Column computer={8} mobile={16} tablet={10}>
              <Header size="large" textAlign="center">
                Contact
              </Header>

              <Segment>
                <div style={{ width: "150px", margin: "1em auto" }}>
                  <a
                    name="845-634-2000"
                    href="tel:845-634-2000"
                    style={{ width: "150px", margin: "1em auto" }}
                  >
                    <Image src="./photos/phone.png" alt="845-634-2000" />
                  </a>
                </div>
                <Divider />
                <Header size="large" textAlign="center">
                  <a href="mailto:rocklandcopy@optonline.net">Email Us</a>
                </Header>
                <Divider />
                <Grid.Row>
                  <Segment vertical style={{ width: "40%", margin: "auto" }}>
                    <a
                      name="yelp profile"
                      href="https://www.yelp.com/biz/rockland-instant-copy-center-new-city-2"
                    >
                      <Image
                        src="./photos/Yelp_trademark_RGB_outline.png"
                        alt="yelp icon"
                      />
                    </a>
                  </Segment>
                  <Segment vertical style={{ overflowX: "scroll" }}>
                    <Header size="medium" textAlign="center">
                      Like us on Facebook!
                    </Header>
                    <FacebookProvider appId="160654848011811">
                      <Like
                        href="https://www.facebook.com/Rockland-Instant-Copy-Center-111337702264363/?ref=br_rs"
                        colorScheme="dark"
                        showFaces
                        share
                      />
                    </FacebookProvider>
                  </Segment>
                </Grid.Row>
              </Segment>
            </Grid.Column>
            <Grid.Column computer={8} mobile={16} tablet={10}>
              <Segment style={{ height: "100vh" }}>
                <Container textAlign="justified">
                  Contact Stuff
                  <GoogleMapReact
                    bootstrapURLKeys={{
                      key: "AIzaSyByD7zi77RtTGA6S7u-e775PLOxkWii7Xs",
                      language: "en"
                    }}
                    style={{ width: "50%", height: "100%" }}
                    center={[41.142538, -73.987943]}
                    zoom={15}
                  >
                    <div lat={41.142538} lng={-73.987944}>
                      <img
                        style={{ position: "absolute", left: -10, top: -40 }}
                        src="./photos/marker.png"
                        alt="marker"
                      />
                    </div>
                  </GoogleMapReact>
                </Container>
              </Segment>
            </Grid.Column>
          </Grid.Row>

          <Divider section />

          <Grid.Row id="about" className="element">
            <Grid.Column computer={6} mobile={16} tablet={6}>
              <Segment>
                <Container textAlign="justified">
                  <Image src="./photos/keith.jpg" fluid alt="Keith" />
                </Container>
              </Segment>
            </Grid.Column>
            <Grid.Column computer={10} mobile={16} tablet={10}>
              <Segment textAlign="center">
                <h3>
                  Since 1984, Keith Henderson has been helping Rockland,
                  Westchester, and Bergen communities with all of their printing
                  needs. Keith was born and raised in Rockland County and now
                  lives in Chestnut Ridge, NY with his family and 2 dogs. With
                  over 30 years of experience in the business, Keith is
                  confident he can help you design, print, and distribute your
                  next printing project.
                </h3>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js